module.exports = __webpack_public_path__ + "img/rotate-360.48eb43b6.svg";